import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@/features/auth-store.service';
import { APP_URLS } from '@/routes/app.paths';

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    return true;
  }

  authStore.logout();

  return router.createUrlTree([APP_URLS.login]);
};
